import React from "react";
import CRUDManager from "../../../shared/components/crud/CRUDManager";
import { userConfig } from "../config";

export default function UserManagement() {
  return <CRUDManager config={userConfig} />;
}
